import { apiGet } from 'api';
import { GetSortOptionsResponse } from '../../types';

export const getSortOptions = (): Promise<GetSortOptionsResponse> =>
  apiGet<GetSortOptionsResponse>('sortoptions');
